



























































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import _ from 'lodash'
import SuporteSalasCentrosCirurgicosStore from '@/components/Suporte/Store/SuporteSalasCentrosCirurgicosStore'
import { DataTablePagination } from '@/types/_'
import { useHospitais } from '@/composables'

@Component
export default class ViewSuporteSalasCentrosCirurgicos extends Vue {
  loadSalasCirurgicas: boolean = false
  loadAddSalasCirurgicas: boolean = false
  loadEditSalaCirurgica: string = ''
  loadCentrosCirurgicos: boolean = false
  loadAddCentrosCirurgicos: boolean = false
  loadEditCentroCirurgico: string = ''

  get getSuporteSalasCentrosCirurgicosStore() {
    return getModule(SuporteSalasCentrosCirurgicosStore, this.$store)
  }

  get paginationSalasCirurgicas() { return this.getSuporteSalasCentrosCirurgicosStore.paginationSalasCirurgicas }
  get paginationCentrosCirurgicos() { return this.getSuporteSalasCentrosCirurgicosStore.paginationCentrosCirurgicos }

  get loadingSalasCirurgicas() { return this.loadSalasCirurgicas }
  set loadingSalasCirurgicas(value: boolean) { this.loadSalasCirurgicas = value }
  get loadingAddSalasCirurgicas() { return this.loadAddSalasCirurgicas }
  set loadingAddSalasCirurgicas(value: boolean) { this.loadAddSalasCirurgicas = value }
  get loadingEditSalaCirurgica() { return this.loadEditSalaCirurgica }
  set loadingEditSalaCirurgica(value: string) { this.loadEditSalaCirurgica = value }
  get loadingCentrosCirurgicos() { return this.loadCentrosCirurgicos }
  set loadingCentrosCirurgicos(value: boolean) { this.loadCentrosCirurgicos = value }
  get loadingAddCentrosCirurgicos() { return this.loadAddCentrosCirurgicos }
  set loadingAddCentrosCirurgicos(value: boolean) { this.loadAddCentrosCirurgicos = value }
  get loadingEditCentroCirurgico() { return this.loadEditCentroCirurgico }
  set loadingEditCentroCirurgico(value: string) { this.loadEditCentroCirurgico = value }

  get hospitalId() { return this.getSuporteSalasCentrosCirurgicosStore.hospitalId }
  set hospitalId(value: string) { this.getSuporteSalasCentrosCirurgicosStore.setHospitalId(value) }
  get hospitais() {
    return useHospitais.hospitaisByCurrentUser.map((h) => {
      const hospital = h
      hospital.id = _.toUpper(h.id)
      hospital.nome = _.toUpper(h.nome)
      return hospital
    })
  }

  fetchHospitais() {
    return useHospitais.loadHospitaisByCurrentUser()
  }

  get salasCirurgicasHeaders() {
    const headers: any[] = [
      { text: 'Nome', value: 'nome', sortable: false },
      { text: 'HisId', value: 'hisId', sortable: false },
    ]

    if (this.centrosCirurgicos && !!this.centrosCirurgicos.length) {
      headers.push({ text: 'Centro cirúrgico', value: 'centroCirurgicoId', sortable: false })
    }

    headers.push({ text: 'Status', value: 'status', sortable: false })
    headers.push({ text: 'Ações', value: '', align: 'center', sortable: false })

    return headers
  }

  get centrosCirurgicosHeaders() {
    return [
      { text: 'Nome', value: 'nome', sortable: false },
      { text: 'HisId', value: 'hisId', sortable: false },
      { text: 'Status', value: 'status', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  get salasCirurgicas() { return this.getSuporteSalasCentrosCirurgicosStore.salasCirurgicas }
  get centrosCirurgicos() { return this.getSuporteSalasCentrosCirurgicosStore.centrosCirurgicos }
  get searchSalaCirurgica() { return this.getSuporteSalasCentrosCirurgicosStore.searchSalaCirurgica }
  set searchSalaCirurgica(value: string) { this.getSuporteSalasCentrosCirurgicosStore.setSearchSalaCirurgica(value) }

  @Watch('searchSalaCirurgica')
  async onChangeSearchSalaCirurgica(value: any) {
    this.salasCirurgicasPagedDebounce({ ...this.paginationSalasCirurgicas })
  }

  get searchCentroCirurgico() { return this.getSuporteSalasCentrosCirurgicosStore.searchCentroCirurgico }
  set searchCentroCirurgico(value: string) { this.getSuporteSalasCentrosCirurgicosStore.setSearchCentroCirurgico(value) }

  @Watch('searchCentroCirurgico')
  async onChangeSearchCentroCirurgico(value: any) {
    this.centrosCirurgicosPagedDebounce({ ...this.paginationCentrosCirurgicos })
  }

  async hospitalChange(id: any) {
    this.getSuporteSalasCentrosCirurgicosStore.setSearchSalaCirurgica('')
    this.getSuporteSalasCentrosCirurgicosStore.setSearchCentroCirurgico('')
    this.getSuporteSalasCentrosCirurgicosStore.setHospitalId(id)

    const params: any = { hospitalId: id }

    this.loadingCentrosCirurgicos = true
    await this.getSuporteSalasCentrosCirurgicosStore.getCentrosCirurgicosPagedSearch({
      ...params,
      ...this.getSuporteSalasCentrosCirurgicosStore.centroCirurgicoPaginationDefault,
    })
    this.loadingCentrosCirurgicos = false

    this.loadingSalasCirurgicas = true
    await this.getSuporteSalasCentrosCirurgicosStore.getSalasCirurgicasPagedSearch({
      ...params,
      ...this.getSuporteSalasCentrosCirurgicosStore.salaPaginationDefault,
    })
    this.loadingSalasCirurgicas = false
  }

  centrosCirurgicosPagedDebounce = _.debounce(param => this.getSuporteSalasCentrosCirurgicosStore.getCentrosCirurgicosPagedSearch(param), 700)
  salasCirurgicasPagedDebounce = _.debounce(param => this.getSuporteSalasCentrosCirurgicosStore.getSalasCirurgicasPagedSearch(param), 700)

  async updatePaginationSalasCirurgicas(pagination: DataTablePagination) {
    if (['', null, undefined].includes(this.hospitalId)) return
    this.loadingSalasCirurgicas = true
    this.salasCirurgicasPagedDebounce(pagination)
    this.loadingSalasCirurgicas = false
  }

  async updatePaginationCentrosCirurgicos(pagination: DataTablePagination) {
    if (['', null, undefined].includes(this.hospitalId)) return
    this.loadingSalasCirurgicas = true
    this.centrosCirurgicosPagedDebounce(pagination)
    this.loadingSalasCirurgicas = false
  }

  adicionarSalaCirurgica() {
    this.getSuporteSalasCentrosCirurgicosStore.setMode({ modal: 'salaCirurgica', mode: 'CREATE' })
    this.getSuporteSalasCentrosCirurgicosStore.clearSalaCirurgica()
    this.getSuporteSalasCentrosCirurgicosStore.setModal({ name: 'salaCirurgica', value: true })
  }

  async editarSalaCirurgica(item: any) {
    this.loadingEditSalaCirurgica = item.id
    this.getSuporteSalasCentrosCirurgicosStore.setMode({ modal: 'salaCirurgica', mode: 'EDIT' })
    this.getSuporteSalasCentrosCirurgicosStore.setSalaCirurgica({ ...item })
    this.getSuporteSalasCentrosCirurgicosStore.setModal({ name: 'salaCirurgica', value: true })
    this.loadingEditSalaCirurgica = ''
  }

  adicionarCentroCirurgico() {
    this.getSuporteSalasCentrosCirurgicosStore.setMode({ modal: 'centroCirurgico', mode: 'CREATE' })
    this.getSuporteSalasCentrosCirurgicosStore.clearCentroCirurgico()
    this.getSuporteSalasCentrosCirurgicosStore.setModal({ name: 'centroCirurgico', value: true })
  }

  async editarCentroCirurgico(item: any) {
    this.loadingEditCentroCirurgico = item.id
    this.getSuporteSalasCentrosCirurgicosStore.setMode({ modal: 'centroCirurgico', mode: 'EDIT' })
    this.getSuporteSalasCentrosCirurgicosStore.setCentroCirurgico({ ...item })
    this.getSuporteSalasCentrosCirurgicosStore.setModal({ name: 'centroCirurgico', value: true })
    this.loadingEditCentroCirurgico = ''
  }

  displayCentroCirurgicoName(id: string) {
    const centroCirurgico = this.centrosCirurgicos.find((c: any) => c.id === id)
    return centroCirurgico ? centroCirurgico.nome : ''
  }

  beforeDestroy() {
    this.getSuporteSalasCentrosCirurgicosStore.clearSalasCirurgicas()
    this.getSuporteSalasCentrosCirurgicosStore.clearCentrosCirurgicos()
    this.getSuporteSalasCentrosCirurgicosStore.clearHospitalId()
  }
}
